import React, {} from "react"

export default function get_str_from_tier_num(tier_num, lower = false, first_letter_capital=false) {
   if (tier_num == 0) {
      var tier_str = 'FREE'
   } else if (tier_num == 1) {
      var tier_str = 'BRONZE'
   } else if (tier_num == 2) {
      var tier_str = 'SILVER'
   } else if (tier_num == 3) {
      var tier_str = 'GOLD'
   } else if (tier_num == 4) {
      var tier_str = 'ASYNC'
   }
   if ((lower) && (tier_str)) {
      tier_str = tier_str.toLowerCase()
      if (first_letter_capital){
         tier_str = tier_str.charAt(0).toUpperCase() + tier_str.slice(1);
      }   
   }
   return tier_str
}
